import React from 'react';
import Icon from '../../../components/AppIcon';
import GlowRing from '../../../components/ui/GlowRing';

const CalorieProgressRing = ({ consumed, burned, goal }) => {
  const netCalories = consumed - burned;
  const progressPercentage = Math.min((consumed / goal) * 100, 100);

  const getRingColor = () => {
    if (progressPercentage <= 50) return 'lime';
    if (progressPercentage <= 80) return 'cyan';
    return 'orange';
  };

  return (
    <div className="glass-card p-6 shadow-neon-orange">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground" style={{ fontFamily: "'Inter Tight', 'Inter', sans-serif" }}>Daily Calories</h3>
        <Icon name="Target" size={20} style={{ color: '#FF6B00' }} />
      </div>
      
      <div className="flex items-center justify-center mb-6">
        <GlowRing
          value={consumed}
          max={goal}
          color={getRingColor()}
          size={160}
          label="Calories"
          sublabel="consumed"
          displayValue={consumed}
          showPercent
        />
      </div>

      <div className="grid grid-cols-3 gap-4 text-center">
        <div>
          <div className="text-sm text-muted-foreground">Goal</div>
          <div className="text-lg font-semibold font-metric text-foreground">{goal}</div>
        </div>
        <div>
          <div className="text-sm text-muted-foreground">Burned</div>
          <div className="text-lg font-semibold font-metric" style={{ color: '#AAFF00' }}>{burned}</div>
        </div>
        <div>
          <div className="text-sm text-muted-foreground">Net</div>
          <div className="text-lg font-semibold font-metric" style={{ color: netCalories > 0 ? '#FF6B00' : '#AAFF00' }}>
            {netCalories > 0 ? '+' : ''}{netCalories}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalorieProgressRing;